import {
    formatMillions
} from 'src/Utils';
import moment from 'moment';

export default function MarketCap({fundSize, shareClassSize}) {
    const renderRows = () => {
        const share = shareClassSize[0];
        const fund = fundSize[0];

        return <tbody>
            <tr>
                <td data-testid="shareClassSizeLabel">Share class size (mil)</td>
                <td className="text-align-right font-weight-bold" data-testid="shareClassSizeValue">
                    {share ? <>
                        {formatMillions(share.dayEndValue)} {share.currency} ({moment(share.dayEndDate, "YYYY-MM-DD").format("DD/MM/YYYY")})
                    </> : '-'}
                </td>
            </tr>
            <tr>
                <td data-testid="FundSizeLabel">Fund size (mil)</td>
                <td className="text-align-right font-weight-bold" data-testid="FundSizeValue">
                    {fund ? <>
                        {formatMillions(fund.dayEndValue)} {fund.currency} ({moment(fund.dayEndDate, "YYYY-MM-DD").format("DD/MM/YYYY")})
                    </> : '-'}
                </td>
            </tr>
        </tbody>
    }

    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0 padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
            <h2 className="card-title" data-testid="sizeHeader">Size</h2>
            <table className="data-table data-table--small data-table--scroll margin-0 highlight">
                {renderRows()}
            </table>
        </div>
    </div>
}